// client/src/reservations/utils/hours.js

// Normalize to array whether the input is an array or an object-map.
const toArray = (v) => Array.isArray(v) ? v : (v ? Object.values(v) : []);

// Build a whitelist of YYYY-MM-DD dates that are OPEN for a given seating_config_id
export function msOpenDates(hoursCtx, range, seatingConfigId) {
  if (!hoursCtx || !range?.start_date || !range?.end_date) return [];

  // rules / applies may be arrays or maps
  const rulesArr   = toArray(hoursCtx.rules);
  const appliesArr = toArray(hoursCtx.applies);

  // Find a specific apply for this seating config (various naming conventions)
  const apply = appliesArr.find(a => {
    if (!a) return false;
    const mode = String(a.mode || a.scope || '').toLowerCase();
    const itemId =
      a.item_id ??
      a.ms_seating_config_id ??
      a.seating_config_id ??
      a.table_type_id ??
      a.itemId;

    const isMSMode = ['modular_seating', 'ms', 'ms_table_type', 'seating_config'].includes(mode);
    return isMSMode && String(itemId) === String(seatingConfigId);
  });

  // Fallback to a global rule if no specific apply found
  const fallbackRuleId = rulesArr.find(r => r.scope === 'all')?.id ?? rulesArr[0]?.id;
  const ruleId = apply?.hours_rule_id ?? fallbackRuleId;
  if (!ruleId) return [];

  // hours_by_rule / exceptions_by_rule can be arrays or maps keyed by rule id
  const hoursRows = Array.isArray(hoursCtx.hours_by_rule)
    ? hoursCtx.hours_by_rule.filter(r => String(r.hours_rule_id) === String(ruleId))
    : (hoursCtx.hours_by_rule?.[ruleId] || []);

  const exceptionRows = Array.isArray(hoursCtx.exceptions_by_rule)
    ? hoursCtx.exceptions_by_rule.filter(e => String(e.hours_rule_id) === String(ruleId))
    : (hoursCtx.exceptions_by_rule?.[ruleId] || []);

  // Build DOW + date maps
  const byDow = new Map();
  hoursRows.forEach(r => {
    const dow = Number(r.day_of_week ?? r.dow ?? r.day ?? 0); // expect 1..7 (Mon..Sun)
    byDow.set(dow, {
      closed: !!r.closed,
      windows: r.time_slots || r.windows || []
    });
  });

  const byDate = new Map();
  exceptionRows.forEach(e => {
    const iso = String(e.exception_date ?? e.date ?? e.day ?? '').slice(0, 10);
    if (!iso) return;
    byDate.set(iso, {
      closed: !!e.closed,
      windows: e.time_slots || e.windows || []
    });
  });

  // Walk the booking horizon and keep only "open" days
  const out = [];
  const start = new Date(range.start_date);
  const end   = new Date(range.end_date);
  for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
    const iso = d.toISOString().slice(0, 10);
    const ex  = byDate.get(iso);
    let open  = false;

    if (ex) {
      open = !ex.closed && (ex.windows?.length > 0);
    } else {
      // JS Sun=0..Sat=6 → Mon=1..Sun=7
      const dow = ((d.getDay() + 6) % 7) + 1;
      const base = byDow.get(dow);
      open = !!(base && !base.closed && (base.windows?.length > 0));
    }
    if (open) out.push(iso);
  }
  return out;
}
